import EnUs from './en-us'

const translations = {
  'en-US': EnUs,
}

export default translations
